import { useMutation, useQueryClient } from "@tanstack/react-query";
import { removeUserFromOrganization } from ".";
import { queryKeys } from "@/lib/useQuery/queryKeys";

export function useRemoveUserFromOrganization(){
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: queryKeys.organisation._def,
        mutationFn: removeUserFromOrganization,
        onSuccess: ()=>{
            queryClient.invalidateQueries({queryKey: queryKeys.organisation._def, exact: false});
        }
    })
}